import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserStartMatch = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解8：比赛开始
          </Title>
          <div className="text-lg">
            <p>一、比赛计时</p>
            <p>1、用于显示比赛的倒计时时间，时间需事先在比赛设置→赛事设置中设置。</p>
            <p>
              2、用于控制选手记分。如果在比赛设置→赛事设置中未勾选计分无视时间，则未开始计时前，选手无法进行记分；计时结束后，选手也无法进行记分。反之，则选手记分不受时间约束。
            </p>
            <p>二、投屏控制</p>
            <p>投屏显示的内容有：</p>
            <div className="my-4">
              <Image src="/manual/start_match/1.png" alt="" />
            </div>
            <p>桌次：编排好的桌次和选手座位分布。</p>
            <p>成绩排名：各轮次和汇总的比赛成绩和排名。</p>
            <p>实时排名：最新的当前成绩和排名。</p>
            <p>团体排名：团体的成绩和排名。</p>
            <p>签到情况：所有选手的签到情况。</p>
            <p>计时+扫码：倒计时记时器和签到/记分二维码。</p>
            <p>规则：在比赛设置→VIP 专区录入的规则文书内容。</p>
            <p>国歌：选择国歌并投屏后，屏幕上显示国旗。</p>
            <p>背景墙：将背景墙进行投屏。</p>
            <p>获奖名单：只显示获奖的队伍或团体，通常在颁奖时使用。</p>
            <p>播放国歌：选择国歌并投屏后，再点击播放或停止，则开始或停止播放国歌。</p>
            <p>屏幕滚动：调整显示内容的滚动间隔时间。</p>
            <p>计时器：对计时器显示效果进行调整，可调参数有背景、大小、位置等。</p>
            <p>签到/记分二维码：对签到/记分二维码显示效果进行调整，可调参数有是否显示二维码、大小、位置。</p>
            <p>显示比赛名：选择是否需要在投屏内容上显示比赛名称。</p>
            <p>报名二维码：投屏签到情况时，是否同时显示报名二维码，以及调整二维码大小。</p>
            <p>在左上角还可以选择轮次，将指定轮次的相关内容进行投屏。</p>
            <p>三、显示内容滚动</p>
            <p>1、显示内容需要滚动时，勾选投屏控制→屏幕滚动→滚动，若未滚动，则取消勾选后重新勾选即可。</p>
            <p>2、左下角有个上下箭头的标记，是滚动开关，任何时候任何界面的内容需要或者不需要滚动时，点击后可以开始滚动或者停止滚动。</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserStartMatch as any, {
  title: '比赛开始:计时与投屏 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统比赛开始操作:倒计时设置与控制、计分时间限制、投屏显示桌次表与实时排名。',
})

export default UserStartMatch
